<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
    <v-flex>
<v-simple-table col-12>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Emailadresse</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mailreciver, index) in mailrecivers" :key="index">
              <td>{{ mailreciver.name }}</td>
              <td>{{ mailreciver.mail }}</td>
              <td @click="remove(mailreciver)"><v-icon>mdi-delete</v-icon></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>
      
    </v-layout>
    <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Empfänger hinzufügen</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Empfänger hinzufügen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Name*" v-model="reciver.name" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Adresse" v-model="reciver.mail" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Schließen</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Mails',

  data: () => ({
    mailrecivers: [],
    dialog: false,
    reciver: {
      name: '',
      mail: '',
      key: 'mailreciver'
    }
  }),
  
  created() {
    this.initReciver()
  },
  methods: {
    getRecivers() {
      this.$http.get('/api/settings/mail/recivers').then((response) => {
        this.mailrecivers = response.data
      })
    },
    initReciver() {
      this.getRecivers()
      this.reciver = {
        name: '',
        mail: '',
        key: 'mailreciver'
      }
    },
    save() {
      this.$http.post('/api/settings/mail/recivers', this.reciver).then(() => {
        this.close()
      })
    },
    remove(reciver) {
      this.$http.delete('/api/settings/mail/recivers', {data: reciver}).then(() => {
        this.close()
      })
    },
    close() {
      this.dialog = false
      this.initReciver()
    }
  }
  
};
</script>
